import api from '../../../api/cat/_soin'

// +++++++++++++    State    ++++++++++++++
const state = () => ({
    soins: [],
    cat: null, //  Conduite à tenir,
    liste_date_protocole: [],
    liste_soins_by_date: [],
    soins_admission: [],
    etat_protocole_soins: 0,

    soins_plainte_patients: [],
    soins_evenement: [],
    soins_cat_consignes: [],
})


// +++++++++++++    Getters     ++++++++++++++
const getters = {
    soins: (state) => {
        return state.soins
    },

    cat: (state) => {
        return state.cat
    },

    liste_date_protocole: (state) => {
        return state.liste_date_protocole
    },

    liste_date_protocole_historique: (state) => {
        return state.liste_date_protocole_historique
    },

    liste_soins_by_date: (state) => {
        return state.liste_soins_by_date
    },

    liste_soins_by_date_historique: (state) => {
        return state.liste_soins_by_date_historique
    },

    soins_admission: (state) => {
        return state.soins_admission
    },

    soins_admission_historique: (state) => {
        return state.soins_admission_historique
    },

    etat_protocole_soins: (state) => {
        return state.etat_protocole_soins
    },

    soins_plainte_patients: (state) => {
        return state.soins_plainte_patients
    },

    soins_evenement: (state) => {
        return state.soins_evenement
    },

    soins_cat_consignes: (state) => {
        return state.soins_cat_consignes
    },
}

// +++++++++++++    Setters     ++++++++++++++
const mutations = {
    SET_SOINS(state, soins) {
        state.soins = soins
    },

    SET_CAT(state, cat) {
        state.cat = cat
    },

    SET_LISTE_DATE_PROTOCOLE(state, liste) {
        state.liste_date_protocole = liste
    },

    SET_LISTE_DATE_PROTOCOLE_HISTORIQUE(state, liste) {
        state.liste_date_protocole_historique = liste
    },

    SET_LISTE_SOINS_BY_DATE(state, liste) {
        state.liste_soins_by_date = liste
    },

    SET_LISTE_SOINS_BY_DATE_HISTORIQUE(state, liste) {
        state.liste_soins_by_date_historique = liste
    },

    SET_SOINS_ADMISSION(state, liste) {
        state.soins_admission = liste
    },

    SET_SOINS_ADMISSION_HISTORIQUE(state, liste) {
        state.soins_admission_historique = liste
    },

    SET_ETAT_PROTOCOLE_SOINS(state, etat) {
        state.etat_protocole_soins = etat
    },

    SET_SOINS_PLAINTE_PATIENTS(state, info) {
        state.soins_plainte_patients = info
    },

    SET_SOINS_EVENEMENT(state, info) {
        state.soins_evenement = info
    },

    SET_SOINS_CAT_CONSIGNES(state, info) {
        state.soins_cat_consignes = info
    },
}

// +++++++++++++    Actions     ++++++++++++++
const actions = {
    getSoins({ commit }) {
        return new Promise((resolve, reject) => {

            api.getSoins().then(
                response => {
                    commit('SET_SOINS', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },



    /**
     * Recupère les conduites à tenir de la consultation en cours
     * @param {*} param0 
     * @param {*} consultation_id 
     */
    getCurrCat({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getCAT(data.consultation_id, data.date_cat).then(
                response => {
                    commit('SET_CAT', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    getSoinsCPN({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSoinsCPN(data.date_cat).then(
                response => {
                    commit('SET_CAT', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    /**
     * Store Conduite à tenir
     * @param {*} param0 
     * @param {*} data   // Contains data sent via CAT form
     * @returns 
     */
    storeCat({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveCAT(data).then(
                response => {
                    // commit('SET_CAT', response)\
                    dispatch('getCurrCat', { consultation_id: data.consultation_id, date_cat: '' })
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },

    /**
     * Store Conduite à tenir
     * @param {*} param0 
     * @param {*} data   // Contains data sent via CAT form
     * @returns 
     */
    storeCatConstante({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveCatConstante(data).then(
                response => {

                    let d = new Date()
                    let dd = (d.getDate() <= 9) ? '0' + d.getDate() : d.getDate();
                    let mm = ((d.getMonth() + 1) <= 9) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
                    let y = d.getFullYear();

                    let d_date = y + '-' + mm + '-' + dd;
                    /* dispatch('getCurrCat', { consultation_id: 0, date_cat: d_date }) */
                    dispatch
                    console.log(d_date)
                    resolve(response);


                }, error => {
                    reject(error);
                }
            )
        })
    },
    // recupère soins sans consultation
    getSoinsSansConsultation({ commit }, date) {
        return new Promise((resolve, reject) => {
            api.getSoinsSansConsultation(date).then(
                response => {
                    //commit('SET_SOIN_EN_COURS', response)
                    commit
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    // recupère soins sans consultation
    updateSoinSansConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.updateSoinSansConsultation(data.medecin, data.soin).then(
                response => {
                    //commit('SET_SOIN_EN_COURS', response)
                    commit
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    getListeDateProtocole({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeDateProtocole(data).then(
                response => {
                    if (data.est_encours == true) {
                        commit('SET_LISTE_DATE_PROTOCOLE', response)
                    } else {
                        commit('SET_LISTE_DATE_PROTOCOLE_HISTORIQUE', response)
                    }
                    
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    getListeSoinsByDate({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeSoinsByDate(data).then(
                response => {
                    if (data.est_encours == true) {
                        commit('SET_LISTE_SOINS_BY_DATE', response)
                    } else {
                        commit('SET_LISTE_SOINS_BY_DATE_HISTORIQUE', response)
                    }
                    
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    getSoinAdmission({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getSoinAdmission(data).then(
                response => {
                    if (data.est_encours == true) {
                        commit('SET_SOINS_ADMISSION', response)
                    } else {
                        commit('SET_SOINS_ADMISSION_HISTORIQUE', response)
                    }
                    
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    saveSoinsAdmission({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveSoinsAdmission(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    saveSoinsConsommable({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveSoinsConsommable(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    startProtocole({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.startProtocole(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    getEtatProtocoleSoins({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getEtatProtocoleSoins(data).then(
                response => {
                    commit('SET_ETAT_PROTOCOLE_SOINS', response)
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    setEtatProtocole({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.setEtatProtocole(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    endProtocole({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.endProtocole(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    saveSoinsProcess({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveSoinsProcess(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    getInfoSoinsEnCours({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getInfoSoinsEnCours(data).then(
                response => {
                    if (data.data_type == 'plainte') {
                        commit('SET_SOINS_PLAINTE_PATIENTS', response)
                    } else if (data.data_type == 'evenement') {
                        commit('SET_SOINS_EVENEMENT', response)
                    } else if (data.data_type == 'cat_consigne') {
                        commit('SET_SOINS_CAT_CONSIGNES', response)
                    }
                    
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    editDiagnosticHn({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.editDiagnosticHn(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    deleteDiagnosticFromHn({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteDiagnosticFromHn(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    saveConstanteForHn({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveConstanteForHn(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    saveOrganeForHn({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveOrganeForHn(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    saveDemandeAnalyseForHn({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveDemandeAnalyseForHn(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    deleteDemandeAnalyseForHn({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteDemandeAnalyseForHn(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    deleteDemandeExamenForHn({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteDemandeExamenForHn(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },

    deletePrescriptionForHn({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deletePrescriptionForHn(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    console.log(error)
                    reject(error)
                }
            )
        })
    },
}



export default {
    state,
    getters,
    actions,
    mutations
}